<template>
  <a-row
    type="flex"
    justify="center"
  >
    <a-col span="6">
      <img alt="allinone_pay" src="~@/assets/images/allinone_pay_logo.svg">
    </a-col>

    <a-col span="12">
      <qrcode-vue
        v-if="qrCode.length > 0"
        :value="qrCode"
        :size="200"
        level="H"
      />
      <img
        alt="allinone_pay"
        class="allinone-scan-desc"
        src="~@/assets/images/allinone_scan_desc.png"
      >
    </a-col>
  </a-row>
</template>

<script>
export default {
  components: {
    QrcodeVue: () => import('qrcode.vue')
  },
  props: {
    qrCode: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.allinone-scan-desc {
  margin-top: 10px;
  width: 200px;
}
</style>
